import { Grid, GridProps, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

export type GridItemProps = Omit<GridProps, "item"> & {
    floatRight?: boolean
}

export function GridItem ({ className, floatRight, ...props }: GridItemProps) {
    const cls = useStyles();

    const floatRightClass = React.useMemo(() => clsx({
        [cls.floatRight]: floatRight === true        
    }), [cls.floatRight, floatRight]);

    return (
        <Grid {...props} item className={`${className} ${floatRightClass}`} />
    )
}

const useStyles = makeStyles(theme => ({
    floatRight: {
        marginLeft: 'auto'
    }
}));